<onboarding-container
  [formValid]="isFormValid$ | async"
  [specialAction]="(doMoneyTransferLater$ | async) ? null : ('onboarding.initial-deposit.special-action' | transloco)"
  [loading]="facade.sendingInitialDeposit$ | async"
  (specialActionClicked)="setMoneyTransferLater()"
  (back)="goBack()"
  (forward)="submit()"
>
  @if (doMoneyTransferLater$ | async) {
    <p class="zero-text p-huge-med">{{ 'onboarding.initial-deposit.hint.headline' | transloco }}</p>
    <p class="zero-text p-base-reg">{{ 'onboarding.initial-deposit.hint.text' | transloco }}</p>
  } @else {
    <p class="zero-text p-huge-med">{{ 'onboarding.initial-deposit.headline' | transloco }}</p>
    <p class="zero-text p-base-reg">{{ 'onboarding.initial-deposit.text' | transloco }}</p>
    <web-design-system-input
      type="number"
      [value]="value$ | async"
      [isValid]="(value$ | async) === '' ? null : (value$ | async | initialDeposit: maxValue) === null"
      [error]="value$ | async | initialDeposit: maxValue | transloco: { value: maxValue | currency }"
      [label]="'onboarding.initial-deposit.value' | transloco"
      [isCurrency]="true"
      (valueChange)="onValueChange($event)"
    />
  }
</onboarding-container>
